(function () {
  'use strict';

  let activeId = 0;
  let currentView = null;

  const LV_ATTR = 'zoom-out'; // Native zoom-out IS our list view

  function grid() {
    return document.querySelector('ul.product-grid');
  }

  function readCard(item) {
    try {
      const a = item.querySelector('a[href*="/products/"]');
      const url = a?.href || '#';
      const title = (
        item.querySelector('[role="heading"]')?.textContent ||
        item.querySelector('product-title')?.textContent || ''
      ).trim();
      const priceHTML = item.querySelector('product-price')?.innerHTML || '';
      const imgs = item.querySelectorAll('.card-gallery img');
      const img1 = imgs[0]?.src || '';
      const img2 = imgs[1]?.src || '';
      const desc = item.querySelector('.lv-product-desc')?.dataset?.desc || '';
      const wishlistEl = item.querySelector('wishlist-btn');
      const wishlistHTML = wishlistEl ? wishlistEl.outerHTML : '';
      return { url, title, priceHTML, img1, img2, desc, wishlistHTML };
    } catch (e) {
      return { url: '#', title: '', priceHTML: '', img1: '', img2: '', desc: '', wishlistHTML: '' };
    }
  }

  function buildOverlay(data) {
    const { url, title, priceHTML, img1, img2, desc, wishlistHTML } = data;
    const full = (desc || '').trim();
    const short = full.slice(0, 180);
    const hasMore = full.length > 180;
    const safeTitle = title.replace(/"/g, '&quot;');
    const safeShort = short.replace(/</g, '&lt;');

    const el = document.createElement('div');
    el.className = 'lv-overlay';
    el.innerHTML = `
      <a class="lv-overlay__link" href="${url}" aria-label="${safeTitle}"></a>
      <a class="lv-overlay__img-wrap" href="${url}" tabindex="-1" aria-hidden="true">
        ${img1 ? `<img class="lv-img lv-img--1" src="${img1}" alt="" width="140" height="140" loading="eager" decoding="async">` : '<div class="lv-img-ph"></div>'}
        ${img2 ? `<img class="lv-img lv-img--2" src="${img2}" alt="" width="140" height="140" loading="lazy" decoding="async">` : ''}
      </a>
      <div class="lv-overlay__body">
        <a class="lv-overlay__title" href="${url}">${title}</a>
        ${full ? `<div class="lv-overlay__desc-box">
          <span class="lv-overlay__desc">${safeShort}${hasMore ? '...' : ''}</span>
          ${hasMore ? `<button class="lv-overlay__more" type="button">Read more</button>` : ''}
        </div>` : ''}
      </div>
      <div class="lv-overlay__side">
        ${wishlistHTML ? `<div class="lv-overlay__wishlist">${wishlistHTML}</div>` : ''}
        <div class="lv-overlay__price">${priceHTML}</div>
        <a class="lv-overlay__btn" href="${url}">View options</a>
      </div>`;

    const btn = el.querySelector('.lv-overlay__more');
    const span = el.querySelector('.lv-overlay__desc');
    if (btn && span) {
      let open = false;
      btn.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        open = !open;
        const item = el.closest('.product-grid__item');
        if (open) {
          span.style.setProperty('display', 'block', 'important');
          span.style.setProperty('-webkit-line-clamp', 'unset', 'important');
          span.style.setProperty('overflow', 'visible', 'important');
          span.style.setProperty('max-height', 'none', 'important');
          span.textContent = full;
          btn.textContent = 'Read less';
          if (item) {
            item.style.setProperty('height', 'auto', 'important');
            item.style.setProperty('max-height', 'none', 'important');
            item.style.setProperty('overflow', 'visible', 'important');
          }
          el.style.setProperty('position', 'relative', 'important');
          el.style.setProperty('min-height', '172px', 'important');
        } else {
          span.style.removeProperty('display');
          span.style.removeProperty('-webkit-line-clamp');
          span.style.removeProperty('overflow');
          span.style.removeProperty('max-height');
          span.textContent = short + '...';
          btn.textContent = 'Read more';
          if (item) {
            item.style.removeProperty('height');
            item.style.removeProperty('max-height');
            item.style.removeProperty('overflow');
          }
          el.style.removeProperty('position');
          el.style.removeProperty('min-height');
        }
      });
    }

    const wl = el.querySelector('.lv-overlay__wishlist wishlist-btn');
    if (wl) {
      wl.style.setProperty('display', 'flex', 'important');
      wl.style.setProperty('opacity', '1', 'important');
      wl.style.setProperty('pointer-events', 'all', 'important');
      wl.style.setProperty('position', 'relative', 'important');
      wl.style.setProperty('inset', 'unset', 'important');
      wl.removeAttribute('data-lv-hidden');
    }

    return el;
  }

  function hideCardElements(item) {
    try {
      ['add-to-cart-component', 'quick-add-component', '.quick-add',
       '.quick-add__product-form-component', 'button.quick-add__button',
       'button.quick-add__button--add', 'button.quick-add__button--choose', 'wishlist-btn']
      .forEach(sel => {
        item.querySelectorAll(sel).forEach(el => {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('opacity', '0', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          el.setAttribute('data-lv-hidden', '1');
        });
      });
    } catch (e) {}
  }

  function restoreCardElements(item) {
    try {
      item.querySelectorAll('[data-lv-hidden]').forEach(el => {
        el.style.removeProperty('display');
        el.style.removeProperty('opacity');
        el.style.removeProperty('pointer-events');
        el.removeAttribute('data-lv-hidden');
      });
    } catch (e) {}
  }

  function activateItem(item) {
    try {
      if (!item.isConnected) return;
      hideCardElements(item);
      if (item.dataset.lvActive) return;
      item.dataset.lvActive = '1';
      item.appendChild(buildOverlay(readCard(item)));
    } catch (e) {}
  }

  function activate(g, instant) {
    const snapId = ++activeId;
    if (!instant) g.classList.add('lv-switching');
    requestAnimationFrame(() => {
      if (activeId !== snapId) { g.classList.remove('lv-switching'); return; }
      g.querySelectorAll('.product-grid__item').forEach(item => activateItem(item));
      requestAnimationFrame(() => {
        if (activeId !== snapId) return;
        g.classList.remove('lv-switching');
        const preload = document.getElementById('lv-preload');
        if (preload) preload.remove();
      });
    });
  }

  function deactivate(g) {
    const snapId = ++activeId;
    g.classList.add('lv-switching');
    requestAnimationFrame(() => {
      if (activeId !== snapId) { g.classList.remove('lv-switching'); return; }
      g.querySelectorAll('[data-lv-active]').forEach(item => {
        item.querySelector('.lv-overlay')?.remove();
        delete item.dataset.lvActive;
        restoreCardElements(item);
      });
      requestAnimationFrame(() => {
        if (activeId !== snapId) return;
        g.classList.remove('lv-switching');
      });
    });
  }

  function onViewChange() {
    try {
      const g = grid();
      if (!g) return;
      const view = g.getAttribute('product-grid-view');
      if (view === currentView) return;
      const prev = currentView;
      currentView = view;

      if (view === LV_ATTR) activate(g, false);
      else if (prev === LV_ATTR) deactivate(g);
    } catch (e) {}
  }

  function init() {
    try {
      const g = grid();
      if (!g) return;

      currentView = g.getAttribute('product-grid-view');

      // Activate immediately if page loaded with zoom-out (native sessionStorage restored it)
      if (currentView === LV_ATTR) activate(g, true);

      new MutationObserver(onViewChange)
        .observe(g, { attributes: true, attributeFilter: ['product-grid-view'] });

      new MutationObserver(mutations => {
        try {
          if (g.getAttribute('product-grid-view') !== LV_ATTR) return;
          mutations.forEach(m =>
            m.addedNodes.forEach(n => {
              if (n.nodeType === 1 && n.classList?.contains('product-grid__item')) activateItem(n);
            })
          );
        } catch (e) {}
      }).observe(g, { childList: true });

    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
